import { type ReactNode, useRef } from 'react';

import { useElementWidth } from '../../hooks/useElementWidth';
import { PageWidthContext } from '../../hooks/usePageWidth';

interface PageContentBoxProps {
  className: string;
  children: ReactNode;
}

export function PageContentBox({
  className,
  children,
}: Readonly<PageContentBoxProps>) {
  const ref = useRef<HTMLDivElement>(null);
  const width = useElementWidth(ref);

  return (
    <PageWidthContext.Provider value={width}>
      <div ref={ref} className={className}>
        {children}
      </div>
    </PageWidthContext.Provider>
  );
}
